import { ButtonWorkspaceDropdown } from "@nova/component-btn"
import {
    selectCoordinateSystem,
    selectEnabled,
    selectHideLegend,
    selectNotation,
    setCoordinateSystem,
    setData,
    setHideLegend,
    setNotation,
    toggleData,
} from "../PDFSlice"
import { useState } from "react"
import { useAppDispatch, useAppSelector } from "integrations/redux/hooks"
import { coordinateSystems, projectionLabel } from "../PDFAnnotations/PDFCoordinateNotations"
import { CRSSelector } from "@nova/component-crs-selector"
import { onBorderTickToggle, onGridLineToggle } from "./PDFButtons"
import { config } from "@nova/configuration/browser"
import { InspectorPanelKeyValueToggle } from "features/map/inspector-panel/InspectorPanelKeyValueToggle"

export const PDFPanelSettings = () => {
    const dispatch = useAppDispatch()
    const notation = useAppSelector(selectNotation())
    const coordinateSystem = useAppSelector(selectCoordinateSystem())
    const [notationMenuOpen, setNotationMenuOpen] = useState(false)
    const enabled = useAppSelector(selectEnabled())
    const hideLegend = useAppSelector(selectHideLegend())

    const currentCoordinateSystem = coordinateSystems[coordinateSystem]

    return (
        <>
            <div className="flex flex-col gap-2">
                <small>Coordinate System</small>
                <CRSSelector
                    allCRSs={Object.values(coordinateSystems)}
                    onSelect={(crs) => {
                        if (crs) {
                            if (!crs.notations[notation]) {
                                dispatch(setNotation(Object.keys(crs.notations)[0]))
                                onGridLineToggle(crs)
                                onBorderTickToggle(crs)
                            }
                            const input = currentCoordinateSystem.proj4
                            const projMatch = input.match(/\+proj=([^\s]+)/)
                            const datumMatch = input.match(/\+datum=([^\s]+)/)

                            const derivedProj = projMatch ? projectionLabel(projMatch[1]) : null
                            const derivedDatum = datumMatch ? datumMatch[1] : null
                            if (derivedProj)
                                dispatch(setData({ type: "projection", data: derivedProj }))
                            dispatch(setData({ type: "datum", data: derivedDatum || "" }))
                            dispatch(setCoordinateSystem(crs.name))
                        } else {
                            const defaultCrs = config.get("organizationSettingCRS")
                            dispatch(setCoordinateSystem(defaultCrs))
                            if (!coordinateSystems[defaultCrs].notations[notation]) {
                                dispatch(
                                    setNotation(
                                        Object.keys(coordinateSystems[defaultCrs].notations)[0]
                                    )
                                )
                                onGridLineToggle(coordinateSystems[defaultCrs])
                                onBorderTickToggle(coordinateSystems[defaultCrs])
                            }
                        }
                    }}
                    className="!h-10 bg-gray-700 !border-none w-full rounded-lg !text-gray-0 !pl-2 !pr-1.5"
                    defaultCRSId={coordinateSystems[coordinateSystem].name}
                />
                <small className="mt-4">Notation</small>
                <ButtonWorkspaceDropdown
                    setMenuOpen={setNotationMenuOpen}
                    onClick={() => setNotationMenuOpen(!notationMenuOpen)}
                    label={currentCoordinateSystem.notations[notation].label}
                    dropdownButtons={Object.values(currentCoordinateSystem.notations).map(
                        (system) => ({
                            label: system.label,
                            onClick: () => {
                                dispatch(setNotation(system.id))
                                setNotationMenuOpen(false)
                            },
                        })
                    )}
                    menuOpen={notationMenuOpen}
                    widthClass="!w-full"
                />
                {/* 4326 is the code for WGS 84. Is there a better way to compare this?*/}
                {"4326" !== currentCoordinateSystem.code && (
                    <div className="text-[#D48C49] mt-3">
                        Downloadable PDF will show a precise version of this preview.
                    </div>
                )}
            </div>
            <div className="border-t border-b border-gray-700 mt-4 py-1">
                <InspectorPanelKeyValueToggle
                    keyTitle="Hide Legend & Borders"
                    isToggled={hideLegend}
                    setIsToggled={() => {}}
                    toggleClassName="justify-between"
                    titleClassName="text-[12px]"
                    className="mb-1"
                    onClick={() => dispatch(setHideLegend(!hideLegend))}
                />
                {/* New Hotspot table UI. When Google links are enabled, remove whats there and uncomment below */}
                <div className="w-full h-px bg-gray-700 mb-1" />
                <InspectorPanelKeyValueToggle
                    keyTitle="Include Hotspot Table"
                    isToggled={enabled["hotspotsTable"]}
                    setIsToggled={() => {}}
                    toggleClassName="justify-between"
                    titleClassName="text-[12px]"
                    className="grow"
                    onClick={() => dispatch(toggleData("hotspotsTable"))}
                />
                {/* <div className="w-full h-px bg-gray-700" />
                <div
                    className="flex items-center w-full gap-1 mt-1"
                    onClick={(e) => {
                        e.preventDefault()
                        dispatch(toggleData("hotspotsTable"))
                    }}
                >
                    <Icons.Icon
                        Icon={Icons.ArrowDropdown}
                        iconClassName={classNames("transition-transform", {
                            "text-white": enabled["hotspotsTable"],
                            "text-white-400 -rotate-90": !enabled["hotspotsTable"],
                        })}
                    />
                    <InspectorPanelKeyValueToggle
                        keyTitle="Include Hotspot Table"
                        isToggled={enabled["hotspotsTable"]}
                        setIsToggled={() => {}}
                        toggleClassName="justify-between"
                        titleClassName="text-[12px]"
                        className="grow"
                    />
                </div>
                <ExpandableContent isOpen={enabled["hotspotsTable"]}>
                    <div
                        className="pl-7"
                        onClick={() => {
                            dispatch(toggleData("useGoogleLinks"))
                        }}
                    >
                        <InspectorPanelKeyValueToggle
                            keyTitle="Use Google Links"
                            isToggled={enabled["useGoogleLinks"]}
                            setIsToggled={() => {}}
                            toggleClassName="justify-between"
                            titleClassName="text-[12px]"
                        />
                    </div>
                </ExpandableContent> */}
            </div>
        </>
    )
}
